<template>
    <div class="top-menu">
        <div class="left">
            <img :src="myavatar" class="my-avatar">
        </div>
        <div class="right">
            <div class="top-btn" v-if="myname == 'w'">
                <a href="admin.html">
                    <i class="fa fa-user"></i> 管理员
                </a>
            </div>
            <div class="top-btn" v-else @click="refresh">
                <i class="fa fa-refresh"></i> 刷新
            </div>
            <div class="top-btn tactic-select"
                 :class="{'canselect': myname == captain}"
                 @click="openTactic"
            >
                <i class="fa fa-list"></i> 战术选择
            </div>
            <div class="top-btn" @click="logout">
                <i class="fa fa-sign-out"></i> 退出登录
            </div>
        </div>
        <!--  tactic-panel -->
        <transition name="tactic-slideIn">
            <div class="tactic-panel" v-show="showTactic">
                <div class="tactic-h2">
                    <h2 @click="closeTactic"><i class="fa fa-angle-left"></i> 返回</h2>
                    <div class="tactic-right">
                        <span>{{ selectedText }}</span>
                        <div class="tactic-sure" @click="makeSureSelect">确定修改</div>
                    </div>
                </div>
                <div class="tactic-inner" id="tactic-inner">
                    <ul class="tactic-ul">
                        <li v-for="(item, index) in tacticList"
                            :key="index"
                            @click="selectTacticItems(index)"
                            :class="{'active': selected == index}"
                        >
                            <div class="title"
                                 :class="{'current': tacticCurrent == index}"
                            >
                                <i class="fa fa-caret-right"></i> {{ item.name }}
                            </div>
                            <div class="small">{{ item.label }}</div>
                        </li>
                    </ul>
                </div>
            </div>
        </transition>
        <!--  tactic-panel end -->
    </div>
</template>

<script>
    import { clearLocal } from "@/common/localstorage";
    import { postOutline, postTacticCurrent } from '@/api/post.js';
    import { getTacticList } from "@/api/get";
    import { fnUrlReplace } from "@/common/fns";
    import { STATUS } from "@/common/const";

    import BScroll from '@better-scroll/core';

    let bScroll = null;

    export default {
        name: "top-menu",
        emits: [ 'selectItem' ],
        props: {
            captain: {
                type: String,
                default() {
                    return 'nobody'
                }
            },
            tacticCurrent: {
                type: Number,
                default() {
                    return 0;
                }
            }
        },
        created() {
            this.initTacticList();
        },
        data() {
            return {
                myname: window.setting.userInfo.username,
                tacticList: [],
                showTactic: false,
                selected: -1
            }
        },
        computed: {
            myavatar() {
                if (window.setting.userInfo.avatar) {
                    return window.setting.userInfo.avatar;
                } else {
                    return window.setting.default_avatar;
                }
            },
            selectedText() {
                let str = '';
                if (this.selected == -1) {
                    str = '';
                }
                if (this.tacticList[this.selected]) {
                    str = this.tacticList[this.selected]['name']
                }
                return str;
            }
        },
        methods: {
            async logout() {
                const isLogout = window.confirm('确定要退出吗？');
                if (isLogout) {
                    const isOutLine = await postOutline(this.myname);
                    // console.log(isOutLine)
                    if (isOutLine.mystatus == STATUS.outline) {
                        clearLocal();
                        fnUrlReplace('login.html');
                    }
                }
            },
            refresh() {
                window.location.reload();
            },
            closeTactic() {
                this.showTactic = false;
            },
            openTactic() {
                if (this.myname != this.captain) {
                    return;
                }
                this.showTactic = true;
                this.$nextTick(() => {
                    if (bScroll) {
                        bScroll.refresh();
                    } else {
                        const wrapper = document.getElementById('tactic-inner');
                        bScroll =  new BScroll(wrapper, {
                            click: true
                        });
                    }
                })
            },
            selectTacticItems(index) {
                this.selected = index;
            },
            async makeSureSelect() {
                if (this.selected == -1) {
                    window.alert('请选择要加载的战术列表');
                    return;
                }
                if (this.selected != this.tacticCurrent) {
                    const res = await postTacticCurrent(this.selected);
                    console.log(res)
                }
                this.closeTactic();
            },
            async initTacticList() {
                const list = await getTacticList();
                this.tacticList = list.tactic_list;
            }
        }
    }
</script>

<style scoped>
    .tactic-slideIn-enter-active,
    .tactic-slideIn-leave-active {
        transition: all 0.3s ease;
    }

    .tactic-slideIn-enter-from,
    .tactic-slideIn-leave-to {
        transform: translate3d(100%, 0, 0);
    }

    .tactic-right{
        display: flex;
        align-items: center;
    }
    .tactic-right span{
        max-width: 80px;
        padding-right: 5px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }

    .tactic-panel{
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background: #fff;
        z-index: 10;
    }
    .tactic-h2{
        background: #022c62;
        color: #fff;
        padding: 0px 15px;
        height: 50px;
        line-height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .tactic-h2 h2{
        font-size: 14px;
    }
    .tactic-sure{
        background: #c33434;
        height: 34px;
        line-height: 34px;
        border-radius: 5px;
        padding: 0 15px;
        font-size: 15px;
    }
    .tactic-inner{
        position: absolute;
        top: 50px;
        right: 0;
        left: 0;
        bottom: 0;
        overflow: hidden;
    }
    .tactic-ul{
        padding: 15px;
    }
    .tactic-ul li{
        background: #f2f2f2;
        padding: 15px;
        margin-bottom: 20px;
    }
    .tactic-ul li.active{
        background-color: #c33434;
        color: #fff;
    }
    .tactic-ul li.active .title.current{
        color: #fffe00;
    }
    .tactic-ul li .title{
        font-weight: 700;
        margin-bottom: 5px;
    }
    .tactic-ul li .title.current{
        color:  #c33434;
    }
    .tactic-ul li .title.current:after{
        content: "now";
        padding-left: 10px;
    }
    .fa{
        margin-right: 5px;
    }
    .top-menu {
        display: flex;
        justify-content: space-between;
        padding: 10px 15px;
        font-size: 14px;
        align-items: center;
        border-bottom: 1px dashed #ccc;
        margin-bottom: 15px;
    }

    .top-menu .left {
        width: 40px;
        height: 40px;
        text-align: center;
        line-height: 36px;
        background: #f2f2f2;
        border-radius: 50%;
    }

    .top-menu .left img {
        display: inline-block;
        width: 80%;
    }

    .top-btn {
        color: #666;
        margin-left: 15px;
        display: inline-block;
    }
    .tactic-select{
        color: #ccc;
    }
    .tactic-select.canselect{
        color: #666;
    }
</style>
